import { useTimelineCtx } from "../ctx";

export const useTimelineIsLast = (itemIdx: number): boolean => {
  const { totalAmtOfItems } = useTimelineCtx();
  return itemIdx === totalAmtOfItems - 1;
};
